<h2 mat-dialog-title>{{ dialogTitle }}</h2>
<div mat-dialog-content>
  <div class="formContainer d-flex justify-content-center">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-group row">
        <mat-form-field class="col-md-6 col-lg-4">
          <mat-label>Libellé</mat-label>
          <input matInput placeholder="" type="text" required formControlName="summary" />
          <mat-error>
            <span *ngIf="f('summary').hasError('required')">Veuillez saisir un libellé</span>
            <span *ngIf="f('summary').hasError('maxLength')">Le nom ne doit pas dépasser 50 caractères</span>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6 col-lg-4">
          <mat-label>Type</mat-label>
          <mat-select formControlName="type" required placeholder="">
            <mat-option *ngFor="let type of trackingHelper.getMaintenanceTypes()" [value]="type">
              {{ trackingHelper.getMaintenanceTypeName(type) }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col-md-6 col-lg-4">
          <mat-label>Fréquence</mat-label>
          <mat-select formControlName="frequency" required placeholder="">
            <mat-option *ngFor="let frequency of trackingHelper.getMaintenanceFrequencies()" [value]="frequency">
              {{ trackingHelper.getMaintenanceFrequencyName(frequency) }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col-md-6 col-lg-4">
          <mat-label>Types de bien</mat-label>
          <mat-hint align="end">Tous les types sont autorisés par défaut</mat-hint>
          <mat-select formControlName="propertyTypes" multiple>
            <mat-option *ngFor="let type of propHelper.getPropertyTypes()" [value]="type">{{
              propHelper.getTypeName(type)
              }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-slide-toggle class="col-md-3" formControlName="energyImpact" [checked]="this.f('energyImpact').value"
          color="primary">Impact énergétique ?</mat-slide-toggle>
        <mat-form-field class="col-md-6 col-lg-4">
          <mat-label>Description</mat-label>
          <input matInput placeholder="" type="text" formControlName="description" />
          <mat-error>
            <span *ngIf="f('description').hasError('maxlength')">La description ne doit pas dépasser 160
              caractères</span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <h4>Conditions</h4>
        <a (click)="addCondition()" appTooltip="Ajouter" class="ml-2">
          <mat-icon color="primary" aria-label="Ajouter">add_circle</mat-icon>
        </a>
      </div>
      <div formArrayName="conditions" *ngFor="let conditionForm of conditions.controls; let i = index"
        class="form-group">
        <div [formGroupName]="i" class="d-flex flex-row">
          <mat-form-field class="col-md-6 col-lg-4">
            <mat-label>Attribut Code</mat-label>
            <input matInput placeholder="" type="text" required formControlName="attributeCode"
              [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let attr of filteredAttributes[i] | async" [value]="attr.code"
                (onSelectionChange)="selectAttribute(attr.code,i,$event)">
                {{attr.code}} - {{attr.display.name}}
              </mat-option>
            </mat-autocomplete>
            <mat-error>
              <span *ngIf="conditions.controls[i].get('attributeCode').hasError('required')">Veuillez saisir un
                code</span>
              <span *ngIf="conditions.controls[i].get('attributeCode').hasError('pattern')">Le code ne peut contenir que
                des majuscules, chiffres et '_'</span>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="col-md-6 col-lg-4" [ngSwitch]="(selectedAttribute[i] | async)?.type">
            <mat-label>Valeur</mat-label>
            <mat-hint align="end">Si vide ou tout, toutes les valeurs sont acceptées </mat-hint>
            <ng-container *ngSwitchCase="'ENUM'">
              <mat-select formControlName="attributeValue" placeholder="">
                <mat-option value="">Tout</mat-option>
                <mat-option *ngFor="let enumValue of (selectedAttribute[i] | async)?.availableValues"
                  [value]="enumValue.code">{{
                  enumValue.code}} ({{enumValue.display.name
                  }})</mat-option>
              </mat-select>
            </ng-container>
            <ng-container *ngSwitchCase="'DECIMAL'">
              <input matInput placeholder="" type="" formControlName="attributeValue" decimalValue
                [unit]="(selectedAttribute[i] | async).unit" />
              <mat-select *ngSwitchCase="'BOOLEAN'" formControlName="attributeValue" placeholder="">
                <mat-option value="">Tous</mat-option>
                <mat-option value="true">Oui</mat-option>
                <mat-option value="false">Non</mat-option>
              </mat-select>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input matInput placeholder="" type="text" formControlName="attributeValue" />
            </ng-container>
          </mat-form-field>
          <a (click)="removeCondition(i)" appTooltip="Supprimer">
            <mat-icon color="primary" aria-label="Supprimer">delete_forever</mat-icon>
          </a>
        </div>
        <mat-divider></mat-divider>
      </div>
      <div class="text-center">
        <button mat-flat-button class="m-2" color="primary" appTooltip="Valider" type="submit"
          [disabled]="formSubmitting">
          Valider
        </button>
        <button mat-flat-button class="m-2" color="primary" mat-dialog-close appTooltip="Annuler" (click)="onNoClick()">
          Annuler
        </button>
      </div>
    </form>
  </div>
</div>
